import { Resource as h, API as p } from "@coveo/platform-client";
const s = class s extends h {
  listFacets(e, t, a = !1, r = !1) {
    const i = a ? s.getBaseUrlAllOrgs() : s.getBaseUrl(), o = a || r || !!t?.sections?.includes("INTERNAL");
    return this.api.post(
      this.buildPath(o ? `${i}/facets` : `${i}/facets/public`, e),
      t
    );
  }
  /**
   * Get a list of the latest activities.
   * @returns Promise<PageModel<ActivityModel>>
   */
  listLatest(e, t) {
    return this.api.post(
      this.buildPath(`${s.getBaseUrl()}/latest`, e),
      t
    );
  }
  /**
   * Fetches activities that a user has subscribed to via the notification service.
   *
   * @param ListActivitiesParams [params]
   * @param ActivityListingFilters [activityFacet]
   * @returns {Promise<PageModel<ActivityModel>>} Paginated list of activities the user is subscribed to.
   */
  listBySubscriptions(e, t) {
    return this.api.post(
      this.buildPath(`${s.getBaseUrl()}/subscriptions/me`, e),
      t
    );
  }
};
s.getBaseUrl = () => `/rest/organizations/${p.orgPlaceholder}/activities`, s.getBaseUrlAllOrgs = () => "/rest/activities";
let l = s;
export {
  l as ActivitiesInternalResource
};
//# sourceMappingURL=ActivitiesInternalResource.js.map
